import { db } from '../../config/firebaseConfig'
const state = {
  shopId: '',
  isStoreLoading: true,
  shopDetails: {}
}

const mutations = {
  'SET_SHOP_ID' (state, shopId) {
    state.shopId = shopId
  },
  'UPDATE_SHOP_DETAILS' (state, shopDetails) {
    state.shopDetails = shopDetails
    state.isStoreLoading = false
  }
}

const actions = {
  getShoppingCart ({ dispatch, state }, { uid, currentCart }) {
    if (uid) {
      return db().ref(`/cart/${state.shopId}/${uid}`).once('value').then((cart) => {
        // console.log(cart.val());
        if (cart.val() && (!currentCart || currentCart.length === 0)) {
          dispatch('setCart', cart.val())
        }
      })
    } else {
      // console.log("User has not logged in");
    }
  },
  getShopDetails ({ commit, state }) {
    return db().ref(`/stores/${state.shopId}/details`).once('value', (shop) => {
      console.log('hehe', state.shopId, shop.val())
      commit('UPDATE_SHOP_DETAILS', shop.val())
    })
  },
  setShopId ({ commit, dispatch, getters }, shopId) {
    commit('SET_SHOP_ID', shopId)
    dispatch('getShopDetails')
    dispatch('listenToCategories')
    dispatch('listenToProductList')
    if (getters.currentUser) {
      dispatch('bindOrders')
      dispatch('getShoppingCart', { uid: getters.currentUser.uid, currentCart: getters.cartItemList })
    }
  },
  clearShopId ({ commit }) {
    commit('SET_SHOP_ID', '')
    commit('UPDATE_SHOP_DETAILS', [])
    commit('UPDATE_PRODUCT_LIST', [])
    commit('UPDATE_CATEGORY_LIST', [])
  }
}

const getters = {
  shopDetails: (state) => {
    return state.shopDetails
  },
  shopId: (state) => state.shopId,
  isStoreLoading: (state) => state.isStoreLoading
}

export default {
  state,
  mutations,
  actions,
  getters
}
